import { UserOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { message } from '@/components/Message';
import React, { useContext, useMemo } from 'react';
import { BaseInfoContext } from '@/context/BaseInfoContext';
import NumericKeyboard from '@/components/NumericKeyboard';
import PosButton from '@/components/PosButton';
import { UserFullInfo } from '@/models/user';
import { playSound } from '@/utils/sound';
import { getUserAvatar } from '@/utils/uiHelper';

export type BindUserProps = {
  // onBind: UserModalProps['onBind'];
  // onUnbind: UserModalProps['onUnbind'];
  // onRecharge: UserModalProps['onRecharge'];
  // isGlobal: boolean;
  userFullInfo?: UserFullInfo;
  renderButton?: (userFullInfo: UserFullInfo) => React.ReactElement;
};

const BindUser: React.FC<BindUserProps> = ({
  // onBind,
  // onUnbind,
  // onRecharge,
  // isGlobal,
  renderButton,
  userFullInfo,
}: BindUserProps) => {
  const [, , helpers] = useContext(BaseInfoContext);

  const customButton = useMemo(() => {
    if (renderButton) {
      return (
        <span
          onClick={() => {
            helpers.showUserModal({
              userFullInfo,
            });
          }}>
          {renderButton(userFullInfo)}
        </span>
      );
    }
  }, [renderButton, userFullInfo]);

  return (
    <>
      {userFullInfo &&
        (customButton ? (
          customButton
        ) : (
          <PosButton
            type={'primary'}
            onClick={() => {
              helpers.showUserModal({
                userFullInfo,
              });
            }}>
            <Space size={5}>
              {getUserAvatar(userFullInfo.user, { size: 32 })}
              <span style={{ marginRight: 8 }}>{userFullInfo.user.nickname}</span>
            </Space>
          </PosButton>
        ))}
      {!userFullInfo && (
        <NumericKeyboard
          trigger={'click'}
          placement={'topLeft'}
          placeholder={'输入手机号查找客户'}
          closeOnScanReceived
          onComplete={num => {
            let code = `${num}`;
            if (num) {
              if (code.length >= 4) {
                helpers.showUserModal({
                  userMobile: code,
                });
              } else {
                message.error('请至少输入4位手机号');
                playSound('error');
              }
            }
          }}>
          {customButton ? (
            customButton
          ) : (
            <PosButton onClick={() => {}} type={'primary'} icon={<UserOutlined />} size={'large'} />
          )}
        </NumericKeyboard>
      )}
    </>
  );
};

export default BindUser;
